import { createAction } from 'redux-actions';

import { constants } from './index';

export const updateSearchQuery = createAction(constants.UPDATE_SEARCH_QUERY);
export const clearSearchQuery = createAction(constants.CLEAR_SEARCH_QUERY);
export const autocompleteListFulfilled = createAction(
    constants.AUTOCOMPLETE_LIST_FULFILLED
);
